/**
 * 钢筋管理
 */
 import axios from '../request';
 export default{
    /**
     * 入库记录
     */
    // 查询入库记录信息
    searchIncome: params =>
        axios.post('/materials/record/recordList', params),
    // 添加入库记录信息
    insertIncome: params =>
        axios.post('/materials/record/recordInsert', params),
    // 入库记录信息详情
    detailsIncome: params =>
        axios.get('/materials/record/recordInfo', {params}),
    // 删除入库记录信息
    deleteIncome: params =>
        axios.get('/materials/record/recordDel', {params}),
    //导出Excel
    exportFiles: params =>
        axios({
        method: 'get',
        url: '/materials/record/recordExportTemplate',
        responseType: 'blob',
        params: params
    }),
    //导入Excel
    exportIncome: params =>
        axios.post('/materials/record/recordExcel', params),
    // 入库记录导出
    exportPutDatas: params =>
        axios({
            method: 'post',
            url: '/materials/record/recordExport',
            responseType: 'blob',
            data: params
        }),


    /**
     * 钢筋类型
     */
    // 查询钢筋类型信息
    searchType: params =>
        axios.post('/materials/steel/steelList', params),
    // 添加钢筋类型信息
    insertType: params =>
        axios.post('/materials/steel/steelInsert', params),
    // 修改钢筋类型信息
    updateType: params =>
        axios.post('/materials/steel/steelUpdate', params),
    // 钢筋类型信息详情
    detailsType: params =>
        axios.get('/materials/steel/steelInfo', {params}),
    // 删除钢筋类型信息
    deleteType: params =>
        axios.get('/materials/steel/steelDel', {params}),

    /**
     * 库存管理
     */
    // 修改库存校正信息
    updateInvent: params =>
        axios.post('/materials/steel/steelCheck', params),
    //预警设置
    setAlarmInvent: params =>
        axios.post('/materials/steel/steelAlertSettings', params),

    /**
     * 校正记录
     */
    //查询校正信息列表
     searchCheckList: params =>
     axios.post('/materials/steel/steelCheckList', params),
    //导出数据
    exportCheckDatas: params =>
        axios({
        method: 'post',
        url: '/materials/steel/steelCheckExport',
        responseType: 'blob',
        data: params
    }),
     /**
      * 消耗记录
      */
    //导出数据
    exportDatas: params =>
        axios({
        method: 'post',
        url: '/materials/record/recordOutExport',
        // url: '/materials/record/recordExport',
        responseType: 'blob',
        data: params
    }),

    /**
     * 报警提示
     */
    //报警提示
    alarmTipsBear: params =>
        axios.post('/materials/steel/selectSteelAlert', params),
 }